// menubar_fix.js
// Fix for Alchemy menubar width after Vite migration
document.addEventListener("turbo:load", () => {
  requestAnimationFrame(() => {
    const bar = document
      .querySelector("alchemy-menubar")
      ?.shadowRoot?.querySelector(".menubar")

    if (!bar) return

    const width = bar.offsetWidth
    if (width > 0) {
      bar.style.setProperty("--panel-width", `${width}px`)
      bar.style.setProperty("--left-offset", "calc(var(--icon-size) + 32px)")
    }
  })
})
